export var version = {
  lib: '2.10091.3',
  product: '2.10091.3',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts